export default __webpack_public_path__ + "static/media/Hallticket1.488ebe65.jpg";